<template>
  <header class="header" :class="{ 'home-header': isHomePage }">
    <div class="header-container">
      <!-- Logo Area -->
      <div class="header-left">
        <div class="logo-area" @click="$router.push('/')">
          <img src="@/assets/logo.png" alt="Logo" />
        </div>

        <!-- Navigation -->
        <nav class="nav-menu">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" class="nav-item" active-class="active">
            {{ item.label }}
            <span class="underline"></span>
          </router-link>
        </nav>
      </div>
      <!-- User Actions -->
      <div class="user-actions">
        <div class="user-avatar" v-if="$store.state.user.userInfo.token" @click="handleClickCenter">
          <img src="@/assets/login-avatar.png" alt="User Avatar" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HomeHeader',
  props: {
    isHomePage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navItems: [{ label: '招标信息', path: '/procurement-info' },
      { label: '增值服务', path: '/services' },
      { label: '政策法规', path: '/policy-regulations' },
      { label: '联系我们', path: '/contact' },
      ],
    };
  },
  methods: {
    handleClickCenter() {
      // get role
      let role = this.$store.getters.role;
      if (role === 'Supplier') {
        this.$router.push('/supplier-center');
      } else if (role === 'Expert') {
        this.$router.push('/expert-center');
      } else if (role === 'Tenderer') {
        this.$router.push('/tenderer-center');
      }else {
        this.$router.push('/admin-center');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 50;
  border-bottom: 1px solid #dbeafe; // blue-100
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  .header-container {
    width: 1200px; // max-w-7xl
    margin: 0 auto;
    padding: 0 16px; // px-4
    height: 80px; // h-20
    display: flex;
    align-items: center;
    justify-content: space-between;

    // @media (min-width: 640px) {
    //   padding: 0 24px; // sm:px-6
    // }

    // @media (min-width: 1024px) {
    //   padding: 0 32px; // lg:px-8
    // }
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .logo-area {

    cursor: pointer;
    margin-right: 36px;

    img {
      width: 128px;
      height: auto;
    }
  }

  .nav-menu {
    display: flex;


    .nav-item {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      color: #2A375E; // text-gray-600
      font-weight: 500; // font-medium
      font-size: 18px; // text-base
      margin-right: 18px;
      position: relative;
      // padding: 8px 0; // py-2
      // transition: color 0.3s;
      // text-decoration: none;

      &:hover,
      &.active {
        color: #5772C3; // text-blue-600
      }

      // .underline {
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 0;
      //   height: 2px;
      //   background-color: #2563eb; // bg-blue-600
      //   transition: width 0.3s;
      // }

      // &:hover .underline,
      // &.active .underline {
      //   width: 100%;
      // }
    }
  }

  .user-actions {
    .user-avatar {
      width: 32px;
      height: 32px;

      cursor: pointer;
      flex-shrink: 0;

      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
}

.home-header {
  position: fixed;
  background: transparent;
  border-bottom: 0; // blue-100
  box-shadow: 0;
}
</style>
